module.exports = __webpack_public_path__ + "static/media/microwave.c70b5c14.svg";